module.exports = __webpack_public_path__ + "img/r-238.9ae6c502.jpg";